module.exports = __webpack_public_path__ + "TRUONGtel.f37b9de6.png";